<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="custom-page">
    <!-- 头部 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <el-icon :size="20"><ArrowLeft /></el-icon>
        <span class="back-text">返回</span>
      </div>
      <div class="price-info">
        <span class="price">¥{{ totalPrice }}</span>
        <!-- <span class="progress-tag">1/2 完成</span> -->
        <!-- <span class="progress-tag">
          {{ currentStepIndex + 1 }}/{{ bom_list.length }} 完成
        </span> -->
        <el-button
          size="large"
          :type="currentStepIndex === bom_list.length - 1 ? 'danger' : 'info'"
          @click="submit"
        >
          {{ currentStepIndex + 1 }}/{{ bom_list.length }} 完成
        </el-button>
        
        <el-button size="large" round @click="userCenterClickHandle">个人中心</el-button>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 轮播图 -->
      <div class="carousel-container">
        <Swiper
          style="height: 600px"
          :modules="swiperModules"
          :loop="true"
          :autoplay="{ delay: 4000, disableOnInteraction: false }"
          :pagination="{ clickable: true }"
          class="swiper-box"
          @swiper="onSwiperInit"
        >
          <SwiperSlide v-for="(item, index) in carouselImages" :key="index">
            <img
              style="width: auto; height: 100%"
              :src="item"
              alt="商品图片"
              class="product-image"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <!-- 产品选项（根据所选型号动态生成） -->
    <div class="product-options">
      <div
        class="option-item"
        v-for="(step, index) in bom_list || []"
        :key="index"
      >
        <span
          class="option-label"
          :class="{ active: currentStepIndex >= index }"
          @click="selectStep(index)"
        >
          <el-icon :size="18">
            <CircleCheckFilled v-if="currentStepIndex >= index" />
            <CircleCheck v-else />
          </el-icon>
          <span>{{ step.stepName }}</span>
          <el-icon
            v-if="currentStepIndex === index && index !== bom_list.length - 1"
            ><Right
          /></el-icon>
        </span>
      </div>
    </div>

    <!-- 下方商品列表滑块 -->
    <div class="product-list">
      <div class="product-list-inner">
        <div class="nav-btn prev swiper-button-prev model-prev"></div>
        <Swiper
          class="product-swiper"
          :modules="swiperModules"
          :loop="false"
          :slides-per-view="'auto'"
          :space-between="30"
          :navigation="{
            nextEl: '.product-list .model-next',
            prevEl: '.product-list .model-prev',
          }"
        >
          <SwiperSlide v-for="m in goods" :key="m.id">
            <div
              class="product-card"
              :class="{ active: m.checked }"
              @click="selectGoods(m)"
            >
              <div class="product-thumb">
                <img :src="m.goodsResult.goodsInfo.thumb" alt="" />
              </div>
              <div class="product-title">
                {{ m.goodsName }}
              </div>
              <div class="product-price">
              <span v-show="currentStepIndex && m.goodsSku.skuPrice.sellPrice" class="icon-plus">+</span>  ¥ {{ m.goodsSku.skuPrice.sellPrice }}
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="nav-btn next swiper-button-next model-next"></div>
      </div>
    </div>

    <GoodsDetail
      v-model:show="goodDetailVisible"
      v-if="goodDetailVisible"
      :detailId="detailId"
    />
    <LoginDialog
      v-model:show="loginDialogShow"
      v-if="loginDialogShow"
      @loginSuccess="submit"
    />
  </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
// 商品详情
const GoodsDetail = defineAsyncComponent(() =>
  import("@/views/GoodsDetail.vue")
);
// 登录弹窗
const LoginDialog = defineAsyncComponent(() =>
  import("@/views/LoginDialog.vue")
);
import { generateUUID } from "@/utils";
import { ElMessage } from "element-plus";
import { ref, computed, defineAsyncComponent } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { getStepModel, getBomBySelection } from "@/api/custom";
import { useRouter } from "vue-router";

// 路由实例
const router = useRouter();

// 选择的键盘型号
const currentStepIndex = ref(0);

// 配件数组
const bom_list = ref([]);

const goods = computed(() => {
  return bom_list.value[currentStepIndex.value]?.bomGoods || [];
});

// 初始化获取型号列表
const getStepModelData = async () => {
  const res = await getStepModel();
  if (Array.isArray(res.bomGoods)) {
    bom_list.value.push({
      stepOrder: res.stepOrder,
      stepName: res.stepName,
      bomGoods: res.bomGoods?.map((item, index) => {
        return {
          ...item,
          checked: index === 0, // 默认选中第一个tab
          show: true,
        };
      }),
    });
    // 默认选中第一个型号
    if (bom_list.value[0].bomGoods.length > 0) {
      bom_list.value[0].bomGoods[0].checked = true;
      getCustomGoods();
    }
  }
};
getStepModelData();

// 获取配件列表
const getCustomGoods = async () => {
  const params = {
    bomProductId: bom_list.value[0].bomGoods.find((item) => item.checked).id,
    selections: [],
  };
  // 遍历bom_list，将checked为true的配件添加到params.selections中
  bom_list.value.forEach((tab, index) => {
    if (
      tab.bomGoods.some((item) => item.checked) &&
      index <= currentStepIndex.value
    ) {
      const checkGood = tab.bomGoods.find((item) => item.checked);
      params.selections.push({
        stepId: checkGood.stepId || -1,
        goodsId: checkGood.id,
        skuCode: checkGood.skuCode,
        quantity: 1,
      });
    }
  });
  console.log(params, "====params====");
  const res = await getBomBySelection(params);
  if (currentStepIndex.value === 0) {
    res.steps.splice(0, 1);
    // 没有bomGoods的步骤，设置为空数组,避免报错
    res.steps.forEach((item) => {
      item.bomGoods = item.bomGoods || [];
    });
    bom_list.value.push(...res.steps);
  }
  bom_list.value[res.currentStepIndex].bomGoods = res?.nextStep?.bomGoods || [];
};

const swiperModules = [Autoplay, Pagination, Navigation];

const carouselImages = computed(() => {
  const currentGoods = bom_list.value[currentStepIndex.value]?.bomGoods.find(
    (item) => item.checked
  );
  return currentGoods?.goodsResult.goodsInfo.images || [];
});

// Swiper 实例
const carouselSwiperInstance = ref(null);
// Swiper 初始化事件
const onSwiperInit = (swiper) => {
  carouselSwiperInstance.value = swiper;
};

const goodDetailVisible = ref(false);
const detailId = ref(0);
// 选择配件
const selectGoods = (m) => {
  if (m.checked) {
    detailId.value = m.id;
    goodDetailVisible.value = true;
    return;
  }
  // 如果当前步骤是最后一个步骤，则不进行任何操作
  if (currentStepIndex.value === bom_list.value.length - 1) {
    return;
  }
  // 重置轮播图到第一张图片
  if (carouselSwiperInstance.value) {
    carouselSwiperInstance.value.slideTo(0);
  }

  if (currentStepIndex.value === 0) {
    bom_list.value = bom_list.value.slice(currentStepIndex.value, 1);
  }
  m.checked = true;
  // 重新选择型号
  goods.value.forEach((item) => {
    item.checked = false;
  });
  m.checked = true;
  // 重新加载配件列表
  getCustomGoods();
};

// 选择步骤
const selectStep = (index) => {
  if (index - currentStepIndex.value > 1) {
    ElMessage.warning("请按步骤选择配件！");
    return;
  }
  currentStepIndex.value = index;

  // 检查当前步骤的 bomGoods 是否有选中项
  const currentStep = bom_list.value[index];
  if (currentStep && currentStep.bomGoods && currentStep.bomGoods.length > 0) {
    const hasCheckedItem = currentStep.bomGoods.some((item) => item.checked);

    // 如果没有选中项，默认选中第一个
    if (!hasCheckedItem) {
      // 如果当前步骤是最后一个步骤，则不继续请求下一步骤的配件
      if (currentStepIndex.value === bom_list.value.length - 1) {
        goods.value[0].checked = true;
      } else {
        selectGoods(currentStep.bomGoods[0]);
      }
    }
  }
};

const loginDialogShow = ref(false);
const submit = () => {
  if (currentStepIndex.value !== bom_list.value.length - 1) {
    ElMessage.warning("请选择配件！");
    return;
  }
  // 校验是否登录
  const token = localStorage.getItem("token");
  if (!token) {
    loginDialogShow.value = true;
    return;
  }

  const selections = [];
  const sessionId = generateUUID();
  // 遍历bom_list，将checked为true的配件添加到params.selections中
  bom_list.value.forEach((tab) => {
    if (tab.bomGoods.some((item) => item.checked)) {
      const checkGood = tab.bomGoods.find((item) => item.checked);
      selections.push({
        sessionId,
        userId: "暂时没有",
        bomProductId: checkGood.bomProductId,
        stepId: checkGood.stepId || -1,
        skuCode: checkGood.skuCode,
        goodsId: checkGood.id,
        quantity: 1,
        unitPrice: checkGood.goodsSku.skuPrice.sellPrice || 0,
        totalPrice: checkGood.goodsSku.skuPrice.sellPrice || 0,
        stepName: tab.stepName,
        ...checkGood,
      });
    }
  });

  // 先将数据保存到localStorage，确保刷新页面时数据不丢失
  sessionStorage.setItem(sessionId, JSON.stringify(selections));

  // 跳转到结算页面，并传递sessionId参数
  router.push({
    name: "configuration-list",
    query: {
      sessionId,
    },
  });
};

const userCenterClickHandle = () => {
  router.push('/user')
}

// 根据当前步骤计算总价,因为总价是根据当前步骤的bomGoods计算的，所以需要根据当前步骤来计算
const totalPrice = computed(() => {
  let total = 0;
  bom_list.value.forEach((tab, index) => {
    if (index <= currentStepIndex.value) {
      if (tab.bomGoods.some((item) => item.checked)) {
        const checkGood = tab.bomGoods.find((item) => item.checked);
        total += checkGood.goodsSku.skuPrice.sellPrice || 0;
      }
    }
  });
  return total;
});

// 返回按钮处理
const goBack = () => {
  // 检查是否有历史记录
  if (window.history.length > 1) {
    // 如果有历史记录，使用router.back()
    router.back();
  } else {
    // 如果没有历史记录（比如直接访问或从外部链接进入），跳转到默认页面
    // 可以根据需要修改默认跳转的页面
    window.location.href = document.referrer || '/';
  }
};
</script>

<style scoped lang="scss">
// 变量定义
$primary-color: #ff0000;
$secondary-color: #ff6b6b;
$text-color: #333;
$text-light: #666;
$bg-color: #ffffff;
$bg-light: #f5f7fa;
$bg-lighter: #f8f8f8;
$border-color: #ddd;
$shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

.custom-page {
  min-height: 100vh;
  background: $bg-color;
  padding: 0;
  position: relative;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: $bg-color;
  z-index: 100;
  box-shadow: $shadow;

  .back-btn {
    display: flex;
    align-items: center;
  }
  .back-text {
    font-size: 16px;
    color: $text-color;
    cursor: pointer;
  }

  .price-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .price {
    font-size: 20px;
    font-weight: bold;
    color: $primary-color;
  }
  .progress-tag {
    background: #f0f0f0;
    color: $text-light;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
}

.main-content {
  margin-top: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .carousel-container {
    width: 100%;
    height: 600px;
    background-color: $bg-light;
    :deep(.swiper-slide) {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(.swiper-pagination-bullet) {
      background-color: #494a4b;
      opacity: 1;
    }
    :deep(.swiper-pagination-bullet-active) {
      background-color: #f1a532;
      opacity: 1;
    }
  }
}

.product-options {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 10px 0 20px;

  .option-item {
    text-align: center;
    cursor: pointer;
  }
  .option-label {
    font-size: 18px;
    color: #8c8c8c;
    padding: 6px 10px;
    background: transparent;
    border-radius: 15px;
    display: inline-block;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .option-label.active {
    color: #67c23a;
    font-weight: 700;
  }
}

/* 下方商品列表滑块 */
.product-list {
  width: 100%;
  display: flex;
  justify-content: center;
}
.product-list-inner {
  position: relative;
  width: calc(100% - 200px);
}
.product-swiper {
  padding: 6px 0;
}

.product-swiper :deep(.swiper-slide) {
  width: 270px; // 固定每个滑块的宽度，结合 slidesPerView: 'auto' 实现自适应个数
  height: auto !important;
  display: flex;
}

.product-card {
  width: 240px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.2s ease;
}
.product-card.active {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.15);
}
.product-thumb {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-title {
  margin-top: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.product-price {
  margin-top: 6px;
  font-size: 18px;
  color: #888;

  .icon-plus {
    color: #f00;
  }
}

/* 自定义箭头 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
  cursor: pointer;
}
.nav-btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 14px;
  height: 14px;
  transform: translate(-50%, -50%) rotate(-45deg);
}
.nav-btn.next::before {
  transform: translate(-50%, -50%) rotate(135deg);
}
.nav-btn.prev {
  left: -100px;
}
.nav-btn.next {
  right: -100px;
}

.selection-boxes {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}
.selection-box {
  width: 100px;
  height: 50px;
  border: 1px solid $border-color;
  border-radius: 4px;
  background: $bg-color;
  transition: all 0.3s ease;
  cursor: pointer;
}
.selection-box:hover {
  border-color: $secondary-color;
  box-shadow: 0 2px 8px rgba($secondary-color, 0.2);
}

@media (max-width: 768px) {
  .product-list-inner {
    width: 90%;
  }
  .nav-btn.prev {
    left: -40px;
  }
  .nav-btn.next {
    right: -40px;
  }
  .product-card {
    width: 200px;
    height: 230px;
  }
  .product-thumb {
    width: 170px;
    height: 90px;
  }
}
</style>
